import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles.css'
import './auth.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
// Register the production app shell for offline use. Dev uses /src/main.jsx and is skipped.
const allowedProtocols = ['http:', 'https:']
const buildScript = [...document.scripts].find((script) => /\/main\.js(?:\?|$)/.test(script.src))
if (buildScript && 'serviceWorker' in navigator && allowedProtocols.includes(location.protocol)) {
  window.addEventListener('load', () => {
    const base = new URL('./', buildScript.src)
    navigator.serviceWorker.register(new URL('sw.js', base).href, { scope: base.href }).catch(() => {})
  })
}
